import axios from 'axios';

import routes from 'app/routes';

export default {

  preparePayment: (successCallback, errorCallback) => {
    axios
      .get(routes.api.members.terminated.preparePayment)
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

};
